import { useEffect } from 'react';
import { TOAST_MS } from '../config/constants';
import { useAppStore } from '../store/appStore';

/** Bottom toast, 3 seconds, cobalt capsule (CombinedMapView.showToast). */
export function Toast() {
  const toast = useAppStore((s) => s.toast);
  const clearToast = useAppStore((s) => s.clearToast);
  useEffect(() => {
    if (!toast) return;
    const id = toast.id;
    const t = window.setTimeout(() => clearToast(id), TOAST_MS);
    return () => window.clearTimeout(t);
  }, [toast, clearToast]);
  if (!toast) return null;
  return (
    <div className="toast" role="status" aria-live="polite">
      {toast.message}
    </div>
  );
}
